module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9PhXu"))).then(() => parcelRequire('d0iPb'));